import React, { useMemo } from 'react';
import { i18n_play_now } from '@yi/i18n/phrases/i18n_play_now';
import { i18n_resume } from '@yi/i18n/phrases/i18n_resume';

import { Episode, Series, getEpisodeUrl } from '~/src/common/lean-back';
import { PlayButtonModal } from '~/src/components/LeanBack/common-components';
import { useLocale } from '~/src/components/LocaleProvider';

import { Button, ButtonWrapper } from './elements';
import { useContinueWatchingEpisode } from '../useContinueWatchingEpisode';

type Props = { series: Series };

export const PlayResumeButton: React.FC<Props> = ({ series }) => {
  const { locale } = useLocale();
  const { isFirstWatch, nextEpisode } = useContinueWatchingEpisode(series);

  const episode = useMemo(() => {
    if (nextEpisode === null) {
      return null;
    }
    return new Episode(nextEpisode);
  }, [nextEpisode]);

  if (episode === null) {
    return null;
  }
  const bntLabel = isFirstWatch ? i18n_play_now(locale) : i18n_resume(locale);

  const episodeUrl = getEpisodeUrl(episode, { pathname: series.localized_path });

  return (
    <PlayButtonModal episode={episode} episodeUrl={episodeUrl}>
      <ButtonWrapper>
        <Button>{bntLabel}</Button>
      </ButtonWrapper>
    </PlayButtonModal>
  );
};
